import { render, staticRenderFns } from "./WorkFlowsViews.vue?vue&type=template&id=1bed378b&scoped=true&"
import script from "./WorkFlowsViews.vue?vue&type=script&lang=js&"
export * from "./WorkFlowsViews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bed378b",
  null
  
)

export default component.exports